import {
  ComingSoonTag,
  DateTime,
  UserSimpleInfo,
} from '@aibees/shared/components';
import {
  memberStatusColorMap,
  StatusTag,
} from '@aibees/shared/components/status-tag';
import { MemberStatus, MemberType } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import type { BrowseApi } from '@aibees/shared/features/advance-table/types';
import { DATE_FORMAT_DD_MMM_YYYY } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { capitalize } from 'lodash-es';
import { useBrowseTeamMembersApi } from '../../hooks/use-browse-team-members-api';
import { TeamMemberEditAction } from './actions/team-member-edit-action';
import { MemberCreditUsed } from './member-credit-used';
import { StyledInactiveMember } from './styles';
import type { MemberWithCreditUsage } from './types';

export const currentPlanConfig: AdvanceTableConfig<MemberWithCreditUsage> = {
  browseApi: useBrowseTeamMembersApi as unknown as BrowseApi<any>,
  rowKey: 'user.id',
  columns: [
    {
      id: 'user',
      key: 'avatar',
      label: 'Team Member',
      render: (_, v) => (
        <StyledInactiveMember inactive={v.status === MemberStatus.disable}>
          <UserSimpleInfo user={v.user} isOwner={v.type === MemberType.Owner} />
        </StyledInactiveMember>
      ),
      width: '25%',
    },
    {
      id: 'type',
      key: 'role',
      label: 'Role',
      render: (_, v) => (
        <StyledInactiveMember inactive={v.status === MemberStatus.disable}>
          <Typography variant="body3" fontWeight={400} color="grey.700">
            {capitalize(v.type)}
          </Typography>
        </StyledInactiveMember>
      ),
      width: '10%',
    },
    {
      id: 'status',
      key: 'status',
      label: 'Status',
      width: '10%',
      render: (v) => (
        <StatusTag
          status={v}
          label={capitalize(v === MemberStatus.disable ? 'Disabled' : v)}
          colorMap={memberStatusColorMap}
          key={v}
          fullWidth
        />
      ),
    },

    {
      id: 'created',
      key: 'created',
      label: 'Joined',
      width: '10%',
      render: (_, v) => (
        <Box display="flex" justifyContent="center" alignItems="center">
          <DateTime value={v.created} tooltipFormat={DATE_FORMAT_DD_MMM_YYYY} />
        </Box>
      ),
    },
    {
      id: 'status',
      key: 'reditCap',
      label: 'Credit Cap',
      width: '15%',
      render: (_, _v) => (
        <Box display="flex" justifyContent="center" alignItems="center">
          <ComingSoonTag size="small" fullWidth />
        </Box>
      ),
    },
    {
      id: 'status',
      key: 'view',
      label: 'View',
      width: '15%',
      // render: (_, v) => (
      //   <MemberCreditUsage
      //     name={`${v.user?.firstName} ${v.user?.lastName}`}
      //     date="Apr 21, 2024 - May 21, 2024"
      //   />
      // ),
      render: (_, _v) => (
        <Box display="flex" justifyContent="center" alignItems="center">
          <ComingSoonTag size="small" fullWidth />
        </Box>
      ),
    },
    {
      id: 'status',
      key: 'credit',
      label: 'Credit',
      width: '15%',
      render: (_, member) => <MemberCreditUsed member={member} />,
    },
  ],
  actions: [TeamMemberEditAction],
  filters: [],
  styles: {
    roundedHeader: true,
  },
  actionsConfig: {
    label: 'Action',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  bordered: 'solid',
  showJumpToPage: true,
};
